import { isLocalAsset } from '../assets/localAssets'
import { localAssetUrl } from '../hooks/useLocalAssetUrls'

/**
 * A reference to a photo, resolved for the editor.
 *
 * Two kinds of reference exist, and both are honest about where the photo is.
 * An `https://` address is a picture that already lives somewhere and is
 * resolved as itself. A `local:` reference is a photo the owner picked here,
 * which lives in this browser until `menu_core_be` has somewhere to put it, and
 * is resolved to an object URL from `useLocalAssetUrls`.
 *
 * Anything else is drawn as a placeholder, so the layout still shows its shape
 * rather than a broken image.
 */
const PLACEHOLDER_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="1600" height="900"><rect width="1600" height="900" fill="#d8cfc4"/><text x="800" y="470" font-family="sans-serif" font-size="56" fill="#6b6157" text-anchor="middle">zdjęcie</text></svg>`

const PLACEHOLDER = `data:image/svg+xml;utf8,${encodeURIComponent(PLACEHOLDER_SVG)}`

export function resolveEditorAssetUrl(assetId: string): string {
  if (isLocalAsset(assetId)) return localAssetUrl(assetId) ?? PLACEHOLDER
  return /^https?:\/\//i.test(assetId) ? assetId : PLACEHOLDER
}
